import FieldValuesFormView from "./FieldValuesFormView";

function FieldValuesForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
  fields,
}) {
  /**
   * This method will handle the fields change event.
   * @param {array} value
   */
  function onFieldsChange(value) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              fields: value,
            }
          : item
      ),
    }));
  }

  return (
    <FieldValuesFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      onFieldsChange={onFieldsChange}
      submitError={submitError}
      fields={fields}
    />
  );
}

export default FieldValuesForm;
